import e from "../../utils/classNames.js";
import t from "./MobileHeaderModal.js";
import n, { useState as r } from "react";
import { isEmpty as i } from "es-toolkit/compat";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/applicationHeader/MobileSubmoduleNavigation.tsx
var s = (s) => {
	let { navItems: c = [], label: l, className: u } = s, [d, f] = r(!1), p = () => f(!d), m = !i(c), h = e("MobileSubmoduleNavigation", "display-flex gap-10 align-items-center", "padding-left-5 padding-right-10", "cursor-pointer", u), g = e(m ? "text-size-12 text-color-dark line-height-14" : "text-size-16 line-height-16 text-color-darkest text-medium text-uppercase", "width-100pct ellipsis-1");
	return /* @__PURE__ */ o("div", {
		className: h,
		onClick: p,
		children: [
			/* @__PURE__ */ o("div", {
				className: "flex-1-1 display-flex flex-column align-items-center width-0",
				children: [/* @__PURE__ */ a("div", {
					className: g,
					children: l
				}), /* @__PURE__ */ a("div", {
					className: "text-medium width-100pct",
					children: c.map((e) => /* @__PURE__ */ a("div", {
						className: "ellipsis-1",
						children: n.cloneElement(e.route, {
							className: "text-size-16 line-height-16 text-color-darkest text-decoration-none",
							onClick: (e) => e.preventDefault()
						})
					}, e.key))
				})]
			}),
			m && /* @__PURE__ */ a("div", {
				className: "text-size-16 text-color-dark",
				children: /* @__PURE__ */ a("span", { className: "uikit-icon icon-chevron-down" })
			}),
			m && /* @__PURE__ */ a(t, {
				show: d,
				children: c.map((e) => /* @__PURE__ */ a("div", {
					className: "margin-y-15 font-size-20",
					children: n.cloneElement(e.route, { className: "text-size-20 text-color-darker" })
				}, e.key))
			})
		]
	});
};
//#endregion
export { s as default };

//# sourceMappingURL=MobileSubmoduleNavigation.js.map